module.exports = __webpack_public_path__ + "img/satoripop.56ab11e8.svg";